/* Gacha Backend v8 - Server-Side Discount Codes + Klaviyo Client API
 * Uses Klaviyo's client-side Subscribe API (no server/private key needed)
 * Public API Key (company_id): SP4RpC
 * List ID: SB7TcY
 * Discount API: https://adorable-cheetah-193.convex.site/api/generate-discount
 */
(function(){
  var KLAVIYO_COMPANY_ID = 'SP4RpC';
  var KLAVIYO_LIST_ID = 'SB7TcY';
  var DISCOUNT_API = 'https://adorable-cheetah-193.convex.site/api/generate-discount';

  function patchGacha() {
    if (typeof window.gachaSubscribe !== 'function') return false;

    window.gachaSubscribe = function(){
      var emailCb = document.getElementById('gachaNotifyEmail');
      var emailInput = document.getElementById('gachaEmailInput');
      if (!emailCb || !emailInput) return;

      var email = emailCb.checked ? emailInput.value.trim() : '';
      if (emailCb.checked && !email) { emailInput.focus(); return; }
      if (!emailCb.checked) return;

      var btn = document.getElementById('gachaNotifyBtn');
      if (btn) { btn.disabled = true; btn.textContent = '\ud83e\udd8b Saving...'; }

      var st = {};
      try { st = JSON.parse(localStorage.getItem('starlittunes_gacha') || '{}'); } catch(e) {}
      var best = st.bestTier || 0;
      var tierNames = {1:'Starlight',2:'Moonbeam',3:'Aurora',4:'Celestial',5:'Divine Grace'};

      var localData = {
        email: email, tier: best,
        tags: 'gacha-subscriber' + (best > 0 ? ',gacha-' + best + 'star' : ''),
        note: "Signed up via Grace's Butterflies Gacha." + (best > 0 ? ' Best pull: ' + best + '\u2605 (' + (tierNames[best]||'') + ')' : ''),
        ts: Date.now()
      };
      try { localStorage.setItem('starlittunes_gacha_notify', JSON.stringify(localData)); } catch(e) {}

      /* ── Generate unique discount code via server ── */
      var discountCode = '';
      var discountPromise = Promise.resolve();
      if (best > 0) {
        discountPromise = fetch(DISCOUNT_API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email: email, tier: best })
        }).then(function(resp) {
          return resp.json();
        }).then(function(data) {
          if (data.success && data.code) {
            discountCode = data.code;
            console.log('[Gacha] Discount code generated:', data.code, data.discountPercent + '% off');
            /* Update the claim area with the actual code */
            var claimArea = document.getElementById('gachaClaimArea');
            if (claimArea) {
              claimArea.innerHTML = '<span style="font-family:monospace;font-size:1.1em;color:#c9a44a;cursor:pointer" onclick="navigator.clipboard.writeText(\'' + data.code + '\').then(function(){alert(\'Code copied!\')})">' + data.code + '</span> <span style="font-size:0.8em;opacity:0.7">(tap to copy)</span>';
            }
            /* Also update the best code display */
            var bestCodeEl = document.getElementById('gachaBestCode');
            if (bestCodeEl) {
              var tierPct = {1:5,2:8,3:12,4:15,5:20};
              bestCodeEl.innerHTML = (tierPct[best]||0) + '% OFF \u2014 Code: <span style="font-family:monospace;color:#c9a44a;cursor:pointer" onclick="navigator.clipboard.writeText(\'' + data.code + '\').then(function(){alert(\'Code copied!\')})">' + data.code + '</span> <span style="font-size:0.7em;opacity:0.6">(tap to copy)</span>';
            }
          } else {
            console.warn('[Gacha] Discount code error:', data.error);
          }
        }).catch(function(err) {
          console.warn('[Gacha] Discount API error:', err);
        });
      }

      /* ── Klaviyo subscription (runs in parallel) ── */
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: "Grace's Butterflies Gacha",
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'Gacha Best Tier': best,
                    'Gacha Tier Name': tierNames[best] || 'None yet',
                    'Gacha Signup Source': "Grace's Butterflies Gacha",
                    'Gacha Signup Date': new Date().toISOString(),
                    'Gacha Reset Date': new Date(Date.now() + 30*24*60*60*1000).toISOString().split('T')[0],
                    'Gacha Cycle': 1
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_LIST_ID
              }
            }
          }
        }
      };

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function(resp) {
        if (resp.ok || resp.status === 202) {
          console.log('[Gacha] Klaviyo subscription successful');
        } else {
          resp.text().then(function(t) { console.warn('[Gacha] Klaviyo error:', resp.status, t); });
        }
      }).catch(function(err) {
        console.warn('[Gacha] Klaviyo fetch error:', err);
      });

      /* ── Klaviyo event (waits for discount code) ── */
      discountPromise.then(function() {
        var eventPayload = {
          data: {
            type: 'event',
            attributes: {
              metric: { data: { type: 'metric', attributes: { name: 'Gacha Signup' } } },
              profile: { data: { type: 'profile', attributes: { email: email } } },
              properties: {
                'Best Tier': best,
                'Tier Name': tierNames[best] || 'None yet',
                'Discount Code': discountCode,
                'Email Subscribed': true,
                'Reset Date': new Date(Date.now() + 30*24*60*60*1000).toISOString().split('T')[0]
              },
              time: new Date().toISOString()
            }
          }
        };
        fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_COMPANY_ID, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify(eventPayload)
        }).catch(function() {});
      });

      var nf = document.getElementById('gachaNotifyForm');
      if (nf) nf.style.display = 'none';
      var ns = document.getElementById('gachaNotifySuccess');
      if (ns) ns.classList.add('show');
    };
    return true;
  }

  if (!patchGacha()) {
    var attempts = 0;
    var interval = setInterval(function() {
      if (patchGacha() || ++attempts > 20) clearInterval(interval);
    }, 500);
  }
})();
